import {
  HomePage,
  ThoiKhoaBieuPage,
  ThoiKhoaBieuChiTietPage,
  NoiTruLayout,
  DiemDanhHangNgay,
  Tiet,
  Tuan,
  DanhSachCongNoPage,
  CauHinhDonGiaPage
} from './pages';
import BaoCaoDiemDanhPage from './pages/bao-cao-diem-danh';
import DiemDanhTrangThai from './pages/danh-muc/diem-danh-trang-thai/DiemDanhTrangThaiPage';
import DiemDanhHangNgayPage from './pages/diem-danh-hang-ngay';

const routes = [
  {
    path: "/home/:tab?",
    component: HomePage,
  },
  {
    path: "/thoi-khoa-bieu",
    component: ThoiKhoaBieuPage,
  },
  {
    path: "/thoi-khoa-bieu-chi-tiet/:id",
    component: ThoiKhoaBieuChiTietPage,
  },
    {
    path: "/noi-tru/:tab?",
    component: NoiTruLayout,
  },
  {
    path: '/diem-danh-hang-ngay/:tab?',
    component: DiemDanhHangNgay
  },
  {
    path: '/diem-danh',
    component: DiemDanhHangNgayPage
  },
  {
    path: '/tiet',
    component: Tiet
  },
  {
    path: '/tuan',
    component: Tuan
  },
  {
    path: '/trang-thai-diem-danh',
    component: DiemDanhTrangThai
  },
  {
    path: '/bao-cao-diem-danh',
    component: BaoCaoDiemDanhPage
  },
  {
    path: '/cong-no-noi-tru',
    component: DanhSachCongNoPage
  },
  {
    path: '/don-gia-noi-tru',
    component: CauHinhDonGiaPage
  }
];

export default routes.map((route) => {
  return {
    ...route,
  };
});
